import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { AppProvider } from '@contexts/AppContext';
import { ThemeModeProvider } from '@contexts/ThemeModeContext';
import GuidedTourProvider from '@contexts/GuidedTourContext';
import { tourList } from './tours';
import Router from '@routes/Router';
import { FCWithChildren } from '@types';

const App: FCWithChildren<{}> = () => (
  <BrowserRouter>
    <ThemeModeProvider>
      <AppProvider>
        <GuidedTourProvider tours={tourList}>
          <Router />
        </GuidedTourProvider>
      </AppProvider>
    </ThemeModeProvider>
  </BrowserRouter>
);
export default App;
